import { WebsiteNavigation } from '@cineamo/api/models/website-configuration/WebsiteNavigaton.enum';
import { WebsiteNavigatonItem } from '@cineamo/api/models/website-configuration/WebsiteNavigatonItem.types';

export function isNavigationVisible(
    navigationItems: WebsiteNavigatonItem[] | undefined,
    section: WebsiteNavigation
): boolean {
    const item = navigationItems?.find((it) => it.section === section);
    if (!item) {
        // BAR is a new section that currently only exists for a single cinema (ID_BELLARIA_KINO), so default to hidden
        if (section === WebsiteNavigation.BAR) return false;
        // DEALS defaults to visible, unlike BAR, and deliberately so (CIN-14499).
        //
        // It was originally specified as opt-in like BAR, on the reasoning that a cinema without
        // offers should not carry an empty page. That reasoning does not survive contact with the
        // lookup above: the stored config uses `{key, visible}` while this function reads
        // `{section, isVisible}`, so `find()` never matches and no cinema can opt *in* to anything.
        // Defaulting to hidden would therefore have made the deals page permanently unreachable —
        // the exact opposite of the intent.
        //
        // So the page ships visible and renders an explicit empty state where a cinema has no
        // published deals. Revisit once the key mismatch is fixed under its own ticket; fixing it
        // here would silently activate every visibility flag cinemas have set over the years and
        // has to be done deliberately, not as a side effect of shipping deals.
        // SHOPS replaces the legacy VOUCHERS section. If a cinema explicitly hid VOUCHERS before
        // SHOPS existed, keep the shop navigation hidden for backward compatibility.
        if (section === WebsiteNavigation.SHOPS) {
            const legacyVouchers = navigationItems?.find((it) => it.section === WebsiteNavigation.VOUCHERS);
            if (legacyVouchers && legacyVouchers.isVisible === false) return false;
        }
        return true;
    }
    return item.isVisible !== false;
}
